<template>
    <el-dialog
    title="新增预置位"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="600px"
    v-dialogDrag
  >
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
      <el-form-item label="预置位值" prop="PresetValue">
        <el-input
          v-model="ruleForm.PresetValue"
          class="w-300px"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="预置位描述" prop="PresetDesc">
        <el-input
          v-model="ruleForm.PresetDesc"
          class="w-300px"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="confirm" :loading="saveLoading">保存</el-button>
      <el-button @click="dialogShow = false" size="small">取消</el-button>
    </div>

  </el-dialog>
</template>

<script>
export default {
  name: 'presetDialog',
  props: {
    show: Boolean,
    // 摄像头编码
    code: {
      type: String,
      defalut: '',
    },
    // ipAddress
    ipAddress: {
      type: String,
      defalut: '',
    },
    port: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    const validateRange = (rule, value, callback) => {
      const orderRule = /^[1-9]\d*$/
      if (!orderRule.test(value)) {
        callback(new Error('请输入[100,255]的数字'))
      } else if (value < 100 || value > 255) {
        callback(new Error('请输入[100,255]的数字'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        PresetValue: '',
        PresetDesc: '',
      },
      rules: {
        PresetValue: [{ required: true, trigger: 'blur', validator: validateRange }],
      },
      saveLoading: false
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
  },
  methods: {
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const url = `http://${this.ipAddress}:${this.port}/VIID/ptz/preset/set/${this.code}`
          const requestOption = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf8',
              Authorization: window.playerToken,
            },
            body: JSON.stringify({
              PresetValue: Number(this.ruleForm.PresetValue),
              PresetDesc: this.ruleForm.PresetDesc,
            })
          }
          this.saveLoading = true
          fetch(url, requestOption)
            .then((response) => {
              if (response.status === 200) {
                return response.json()
              }
              throw new Error('网络请求失败')
            })
            .then((res) => {
              if (res.ErrCode === 0) {
                this.$emit('reload')
                this.dialogShow = false
              } else {
                console.log('预置设置失败', res.ErrMsg)
              }
            })
            .catch((error) => {
              console.log('服务器连接异常云台')
              console.log(error)
            })
            .finally(() => {
              this.saveLoading = false
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
